import React from 'react'
import {GetPageName,getUserRole} from '../Custom/Custom';
import { GlobalLoading } from 'react-global-loading';
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { getUserClaimsForUi, hasAuthSession } from '../utils/authStorage';

function NotFound() {

  const navigate = useNavigate();
  let pageText='';
  let pageNameObject=''
  let userRoleObject=''
  
  const loggedIn = hasAuthSession();
  if (loggedIn) {
    const userData = getUserClaimsForUi();
    if (userData) {
      userRoleObject = getUserRole(userData.id);
    }
  }
  pageNameObject= GetPageName(userRoleObject); 


  if(pageNameObject.pagePath[0]==='Not Found' && !loggedIn){
    pageText="before_login_page_not_found";
    navigate("/")
    window.location.pathname = "/";
  }else if(pageNameObject.pagePath[0] !=='Not Found' && loggedIn){
  //  alert("loading");
  //  showLoading(true)
    // pageText='Loading.........';
  }else if(pageNameObject.pagePath[0]==='Not Found' && loggedIn){ //after login
    pageText="after_login_page_not_found";
  }else if(pageNameObject.pagePath[0]!=='Not Found' && !loggedIn){
    pageText='before_login_page_not_found';
    window.location.pathname = "/";
     navigate("/")
  }
 
  return (
    <>
    <GlobalLoading />

    { (pageText==='after_login_page_not_found') &&
        <div className="row ">
            <div className="card">
              <h4 className="p-3 text-center text-danger fw-bold">Page Not Found</h4>
            </div>
        </div>
    }

    {/* { (pageText==='before_login_page_not_found') &&
        <div className="row mt-5">
            <div className="card">
              <h4 className="p-3 text-center text-danger fw-bold">Please login</h4>
            </div>
            <div style={{textalign: "center"}}>
            <Link class="btn btn_orange"
                to="/">Login</Link>
             </div>
        </div>
    } */}
   
    </>
  )
}

export default NotFound
